<script setup lang="ts">
import { computed, inject, Ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { Subjekt } from '/@src/client-portal'

const emptyResponse = inject<any>('emptyResponse')
const isReadOnly = inject('isReadOnly')
const subjektDetail = inject<Ref<Subjekt>>('subjektDetail')
const { t } = useI18n()

const data = computed(() =>
  isReadOnly
    ? {
        nazov: emptyResponse?.ziadatel?.organizacia?.organizaciaRef.nazov,
        ico: emptyResponse?.ziadatel?.organizacia?.organizaciaRef.ico,
        dic: emptyResponse?.ziadatel?.organizacia?.organizaciaRef.dic,
        jePlatcaDph: emptyResponse?.ziadatel?.organizacia?.jePlatcaDph,
        icDph: emptyResponse?.ziadatel?.organizacia?.icDph,
        pravnaFormaNazov: emptyResponse?.ziadatel?.organizacia?.pravnaForma.nazov,
        email: emptyResponse?.ziadatel?.organizacia?.primarnyKontakt?.email,
        telefon: emptyResponse?.ziadatel?.organizacia?.primarnyKontakt?.telefonneCislo,
      }
    : {
        nazov: subjektDetail?.value.organizacia?.nazov,
        ico: subjektDetail?.value.organizacia?.ico,
        dic: subjektDetail?.value.organizacia?.dic,
        jePlatcaDph: subjektDetail?.value.organizacia?.jePlatcaDph,
        icDph: subjektDetail?.value.organizacia?.icDph,
        pravnaFormaNazov: subjektDetail?.value.organizacia?.pravnaForma?.nazov,
        email: subjektDetail?.value.organizacia?.primarnyKontakt?.email,
        telefon: subjektDetail?.value.organizacia?.primarnyKontakt?.telefonneCislo,
      }
)
</script>

<template>
  <IDSKHeading as="h2" variant="l">
    {{ t('zoppm.step7.pravnickaOsoba.secondHeading') }}
  </IDSKHeading>

  <ValidationWrapper v-slot="slotProps" name="ziadatel">
    <IDSKInput v-bind="slotProps" readonly hidden />
  </ValidationWrapper>

  <DisplayList v-if="!isReadOnly" bold="title" variant="inline" inline-layout="one-half">
    <dt>{{ t('zoppm.step7.pravnickaOsoba.nazovZiadatela') }}</dt>
    <dd>{{ data?.nazov }}</dd>
    <dt>{{ t('zoppm.step7.pravnickaOsoba.ico') }}</dt>
    <dd>{{ data?.ico }}</dd>
    <dt>{{ t('zoppm.step7.pravnickaOsoba.dic') }}</dt>
    <dd>{{ data?.dic }}</dd>
    <dt>{{ t('zoppm.step7.pravnickaOsoba.platcaDph') }}</dt>
    <dd>{{ data?.jePlatcaDph ? 'Áno' : 'Nie' }}</dd>
    <dt>{{ t('zoppm.step7.pravnickaOsoba.icDph') }}</dt>
    <dd>{{ data?.icDph }}</dd>
    <dt>{{ t('zoppm.step7.pravnickaOsoba.pravnaForma') }}</dt>
    <dd>{{ data?.pravnaFormaNazov }}</dd>
    <dt>{{ t('zoppm.step7.fyzickaOsoba.email') }}</dt>
    <dd>{{ data?.email }}</dd>

    <dt>{{ t('zoppm.step7.fyzickaOsoba.telefon') }}</dt>
    <dd>{{ data?.telefon }}</dd>
  </DisplayList>

  <DisplayList v-else bold="title" variant="inline" inline-layout="one-half">
    <dt>{{ t('zoppm.step7.pravnickaOsoba.nazovZiadatela') }}</dt>
    <dd>{{ t('zoppm.step7.pravnickaOsoba.nazovZiadatelaMeno') }}</dd>
    <dt>{{ t('zoppm.step7.pravnickaOsoba.ico') }}</dt>
    <dd>{{ t('zoppm.step7.pravnickaOsoba.icoVzorove') }}</dd>
    <dt>{{ t('zoppm.step7.pravnickaOsoba.dic') }}</dt>
    <dd>{{ t('zoppm.step7.pravnickaOsoba.dicVzorove') }}</dd>
    <dt>{{ t('zoppm.step7.pravnickaOsoba.platcaDph') }}</dt>
    <dd>{{ data?.jePlatcaDph ? 'Áno' : 'Nie' }}</dd>
    <dt>{{ t('zoppm.step7.pravnickaOsoba.icDph') }}</dt>
    <dd>{{ t('zoppm.step7.pravnickaOsoba.icDphVzorove') }}</dd>
    <dt>{{ t('zoppm.step7.pravnickaOsoba.pravnaForma') }}</dt>
    <dd>{{ data?.pravnaFormaNazov }}</dd>
  </DisplayList>
</template>

<style lang="scss"></style>
